export default __webpack_public_path__ + "static/video-international-5efc7078f127d3decb35477c9a30af7c.mp4";